import { EasyParserGLModel } from "./EasyParserGLModel";
import { EasyParserPDB } from "./EasyParserPDB";
import { FileInfo } from "@/FileSystem/FileInfo";
import { getFormatInfoGivenType } from "../../Types/MolFormats";
import { EasyParserIAtomList } from "./EasyParserIAtomList";
import { EasyParserMol2 } from "./EasyParserMol2";
/**
 * This function creates an EasyParser object from a given source.
 *
 * @param {IFileInfo | GLModel | IAtom[] | undefined} src The source to parse.
 * @returns {EasyParserParent} The EasyParser object.
 */
export function makeEasyParser(src) {
    // If undefined, return an empty parser.
    if (src === undefined) {
        return new EasyParserIAtomList([]);
    }
    // If its an array, assume it's an atom list.
    if (Array.isArray(src)) {
        return new EasyParserIAtomList(src);
    }
    if (src.selectedAtoms !== undefined) {
        return new EasyParserGLModel(src);
    }
    // Get type of src.
    const typ = new FileInfo(src).getFileType();
    const formatInfo = getFormatInfoGivenType(typ);
    if (formatInfo?.primaryExt === "pdb") {
        return new EasyParserPDB(src);
    }
    // TODO: Below should be mol2!
    return new EasyParserMol2(src);
}
